import styled from "styled-components";

export const AboutUsImageContainer = styled.div`
    display: grid;
    grid-template-columns: 1fr auto;
    gap: 32px;
    align-items: center;
    font-style: italic;
    font-size: 18px;
    line-height: 1.6;
    font-weight: 500;
    color: var(--color-primary);
    margin: 40px 0 60px;

    @media (max-width: 700px) {
        grid-template-columns: 1fr;
        text-align: center;
    }
`;

export const AboutUsImageText = styled.p`
    margin: 0;
`;

export const AboutUsImg = styled.img`
    max-width: 382px;
    width: 100%;
    height: auto;
    border-radius: var(--radius-lg);
    box-shadow: var(--shadow-md);

    @media (max-width: 700px) {
        margin: 0 auto;
    }
`;
